import { useMemo } from 'react';
import { UISelect, UISelectOption } from '@/comps/ui/UISelect';
import { translateSafe } from '@/utils/translations';

type CategoryKindSelectorProps<T> = {
  availableKinds: T[];
  value: T;
  onChange: (value: T) => void;
};

export function CategoryKindsSelector<T extends string>({
  availableKinds,
  value,
  onChange,
}: CategoryKindSelectorProps<T>) {
  const categoriesKindsSelectorOptions: UISelectOption<T>[] = useMemo(() => {
    return availableKinds.map((kind) => ({
      value: kind,
      label: translateSafe('customAggregateCategories', kind),
    }));
  }, [availableKinds]);

  return (
    <UISelect value={value} options={categoriesKindsSelectorOptions} onChange={onChange} placeholder="Select a kind" />
  );
}
